<template>
  <PageLayout class="history-page">
    <PageTitle class="page-title">Історія замовлень</PageTitle>
    <InsuranceOsagoInfo />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import InsuranceOsagoInfo from '../../views/insuranceOsagoInfo/index.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';

export default {
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageLayout, PageTitle, InsuranceOsagoInfo },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
